import { Trip_Filters } from "./tripPlanner_types";

export const mapLayerIds = ["main","sat","carnav"];

export const negative_review_icon_class = "ai-dislike";
export const neutral_review_icon_class = "ai-like";
export const postive_review_icon_class = "ai-heart";

export type vehicleTypeID = "Au"| "B"| "B-M"| "Bo"| "C"| "C-C"| "C-V"| "F"| "F-C"| "M"| "O"| "P"| "P-M"| "S"| "S-C"| "T"| "T-C"| "T-D"| "T-H"| "V";

export type s2n_reserve_quote = {
	baseRate:number;
	taxesAndFeeds:number;
	total:number;
	checkIn:string;
	checkOut:string;
	spot: {
		id:number;
		name:string;
		category: {
			id:number;
			name:string;
		}
	};
	park: {
		id:number;
		name:string;
	}
}

export type s2n_reserve_params = {
	guests: {
		adults:number;
		children:number;
		infants:number;
		pets:number;
	};
	bookingInformation: {
		spotId:number;
		parkId:number;
		checkIn:Date;
		checkOut:Date;
	};
	vehicleProfile: {
		length:number;
		slideouts: {
			driver:boolean;
			passenger:boolean;
			rear:boolean;
		};
		type:string|null;
	};
};

type s2n_spot_availability = {
	available:boolean;
	id:string;
	name:string;
	price:string;
}

export type s2n_spots_availability = {
	spots: s2n_spot_availability[];
	id:string;
	name:string;
};

export type InstantBookSettings = {
	parkId:number;
	dates:Date[];
	vehicleType:vehicleTypeID|"";
	vehicleLength:number;
	slideouts: {
		driver:boolean;
		passenger:boolean;
		rear:boolean;
	};
	guests: {
		adults:number;
		children:number;
		infants:number;
		pets:number;
	};
}

export type UserEnteredVehicle = {
	vehicleTypeID:vehicleTypeID;
	make:string;
	model:string;
	length:number;
	length_in:number;
	width:number;
	width_in:number;
	height:number;
	height_in:number;
	driver_slideout:boolean;
	passenger_slideout:boolean;
	rear_slideout:boolean;
	primary:boolean;
};

export type editUserVehicleParams = {
	vehicleID:number;
	length:number;
	width:number;
	height:number;
	length_in:number;
	width_in:number;
	height_in:number;
	driver_slideout:boolean;
	passenger_slideout:boolean;
	rear_slideout:boolean;
	primary:boolean;
};

export type Folder = {
	folderID:number;
	folderName:string;
	itemCount:number;
};

export interface searchParams {
	query: string;
	autofillData:autofillData|null;
	gpt_resp?:any;
	filters?:Record<string,Array<string>>;
	instantBook?:boolean;
};

export interface autofillClick_searchParams {
	autofill_query: string;
	autofill_types: string;
	autofill_desc: string;
};
/*
export interface campListAmenityCounts {
	laundry: number;
	wifi: number;
	pool: number;
	showers: number;
	store: number;
};
*/

export interface cgSearchResponse {
	html: string;
	filter_amenities_counts: Record<string,number>;
	page?:number;
	radius?:number;
	filters?:any;
	numResults?:number;
	campNameSearch?:boolean
};

export type Trip_oldPlannerResponse_addStop = {
	stopListHTML:string,
	directions:any,
	changedClusters:Array<Trip_oldCluster>,
	changedClusterIndices:Array<number>,
	newCluster:Trip_oldCluster,
	newClusterIndex:number,
	endPointIndices:Array<number>
};

export type Trip_oldPlannerResponse_removeStop = {
	newCluster1:Trip_oldCluster,
	newCluster1_index:number,
	newCluster2?:Trip_oldCluster,
	newCluster2_index?:number
	directions:any,
	stopListHTML:string,
	endPointIndices:Array<number>,
	queries: Array<string>
};

export type settingsReqParams = {
	"page": string;
	"data": Record<string,string>;
};

export type settingsUpdateResponse = Record<"fn" | "ln" | "email" | "username" | "country" | "city" | "address" | "state" | "bio" | "phone" | "dashoffset" | "completionPercentage",string>;

export interface addVehicleResponse {
	html: string;
	dashoffset:string;
	completionPercentage:string;
};

export interface prefUpdateResponse {
	dashoffset:string;
	completionPercentage:string;
}

export type autofillData = {
	"query_type": string|null;
	"query_val": string|null;
};

export type autofillData_cachedForm = {
	t: string|null;
	v: string|null;
}


interface Trip_ReqFields {
	"filters":Trip_Filters;
	"autofillData":Array<autofillData>;
}

export interface Trip_ReqFields_Regional extends Trip_ReqFields {
	"searchQuery":string;
}

export interface Trip_ReqFields_E2E extends Trip_ReqFields {
	"startQuery":string;
	"endQuery":string;
	"autofillData2":autofillData;
}

export interface Trip_ReqFields_stopByStop extends Trip_ReqFields {
	"stopQueries":Array<string>;
}

export type creatFolderFields = {
	folderName: string;
};

export type rvData = {
	class: string;
	make: string;
	model: string;
	electric_rating: number;
};

export type amenitiesList = {
	wifi?: boolean| null;
	showers?: boolean| null;
	pool?: boolean| null;
	cable?: boolean| null;
	laundry?: boolean| null;
	food?: boolean| null;
};

export type userData = {
	f_name:string;
	l_name:string;
	home_addr?:string | null;
	home_city?:string | null;
	home_adminArea_lvl2?:string | null;/*county*/
	home_adminArea_lvl1?:string | null;/*state*/
	home_country?:string | null;
}


interface review {
	rating:number;
	text:string;
	date: {"$date":string} | Date;
	dateDiff?:number;
	timeDiffMsg?:string;
};

export interface RVtrippy_campReviewResponse {
	_id: {$oid:string};
	uid:number;
	disp_name:string;
	starts:number;
	text:string;
	date: {"$date":string} | Date;
	stars:number;
	dateDiff?:number;
	timeDiffMsg?:string;
	stars_html?:string;
};

export interface RVtrippy_campReviewEditResponse extends RVtrippy_campReviewResponse{};

export type RVtrippy_campReviewReplyResponse = {
	uid:number;
	disp_name:string;
	text:string;
	campID:number;
	date:Date|{$date:string};
	dateDiff:number;
	timeDiffMsg:string;
}

interface campReview extends review {
	campID:number;
	dateDiff?:number;
	timeDiffMsg?:string;
	stars_html?:string;
	/*
	 * stars_html is used for formatting campReview for Mustache
	 * when campReview first created, won't have stars_html
	 * stars_html only used by Mustache -- not intended for use anywhere else
	 */
};

export type reviewReplyData = {
	text:string;
	replyingToID:string;
	campID:number;
}

export enum campReview_orderBy {
	Oldest,
	Newest,
	RatingHigh,
	RatingLow
};

interface tripReview extends review {
	tripID: number;
};

export interface editReviewParams extends review {
	reviewID:string;
};

export interface RVtrippy_reviewReply extends reviewReplyData{
	disp_name:string;
	upvotes:number;
	downvotes:number;
	date:Date|{"$date":string};
	replies?: Array<RVtrippy_reviewReply>;
	timeDiffMsg?:string;
}

export interface RVtrippy_campReview extends campReview {
	uID:number;
	curUserReview:boolean;/*true if currently signed in user wrote this review*/
	upvotes:number;
	downvotes:number;
	dateDiff?:number;/*dateDiff set by js function when reviews gotten */
	replies?: Array<RVtrippy_reviewReply>;
	imageKeys: Array<string>
};

export interface external_campReview extends campReview {
	source:string;

}

export type Campground = {
	camp_name:string;
	campID:number;
	latitude:number;
	longitude:number;
	city:string;
	administrative_area_level_1:string;
	administrative_area_level_1_long:string;
	administrative_area_level_2:string;
	site_url:string;
	reserve_url:string;
	reserve_phone:string;
	info_phone:string;
	email:string;
	open_date:Date|string;
	close_date:Date|string;
	max_RV_width:number;
	max_RV_height:number;
	max_RV_length:number;
	num_reviews:number;
	num_sites:number;
	ada_access:boolean;
	checkin_time:string;
	checkout_time:string;
	parkID:number;
	genie_score:number;
	stock_img_url:string;
	price_low:number|"?";
	price_high:number|"?";

	street_address:string;
	overall_summary?:string;
	positive_summary?:string;
	negative_summary?:string;

	genieMatch?:number;

	description?:string;
	// s2n_slug?:string|null;
	s2n_id?:number|null;
};

export type CampgroundData = {
	camp: Campground;
	amenities: Array<string>;
	activities?: Array<string>;
	affiliations?: Array<string>;
	cell_providers?: Array<string>;
	discounts?: Array<string>;
	cards_accepted?: Array<string>;
	nearby_poi?: Array<string>;
	pictures?: Array<string>;
	social_media?: Record<string,string>;
}

export type Trip_oldCluster = {
	selectedCamp:CampgroundData;
	altStops:Array<CampgroundData>;
	numNights?: number;
};

export type Trip_oldCluster_sendFormat = {
	selectedCamp:number;
	altStops:Array<number>;
	numNights?: number;
}

export type Trip_old = {
	stopListHTML: string;
	start_cluster:Trip_oldCluster;
	end_cluster:Trip_oldCluster;
	clusters:Array<Trip_oldCluster>;
	directions?: google.maps.DirectionsResult | any;
	startDate?: Date;
	queries: Array<string>;
	setFilters:Trip_Filters;
	endPointIndices:Array<number>;
	lockedStopIndices?:Array<number>;
	lockedLeg_indexRanges?:Array<{startIndex:number,endIndex:number,legIndex:number}>
	tname:string,
	tdesc:string,
	isSavedTrip:boolean,
	tripID:number
};

export type Trip_sendFormat = {
	start_cluster: Trip_oldCluster_sendFormat;
	end_cluster: Trip_oldCluster_sendFormat;
	clusters: Array<Trip_oldCluster_sendFormat>;
	startDate?: Date;
	name:string;
	description:string;
}

export type TripLegData = {
	distance:google.maps.Distance;
	time:google.maps.Duration;
};

export type TripLegsData = {
	numLegs:number;
	legDataArr:TripLegData[];
};

export type newStopReq_fromQuery = {
	clusterBefore:Trip_oldCluster;
	clusterAfter:Trip_oldCluster | null;
	queryData:Trip_ReqFields_stopByStop;
	indexToInsertAt:number;
	selectedStops:Array<CampgroundData>;
};

export type S3_presignedPost = {
	url:string,
	fields:any,
	response?: string;
}